import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ChatInfo,
  ParticipantChange,
  ParticipantMessages,
  PendingMessages,
  TimeLineEntry,
  UnreadTidemark
} from '../chat-modal.store';
import { ChatTimelineInfoEntryComponent } from './chat-timeline-info-entry/chat-timeline-info-entry.component';
import { ChatTimelineParticipantChangeEntryComponent } from './chat-timeline-participant-change-entry/chat-timeline-participant-change-entry.component';
import { ChatTimelineParticipantMessagesEntryComponent } from './chat-timeline-participant-messages-entry/chat-timeline-participant-messages-entry.component';
import { ChatTimelinePendingMessagesEntryComponent } from './chat-timeline-pending-messages-entry/chat-timeline-pending-messages-entry.component';
import { ChatTimelineUnreadTidemarkComponent } from './chat-timeline-unread-tidemark/chat-timeline-unread-tidemark.component';

@Component({
  selector: 'app-chat-timeline-entry',
  templateUrl: './chat-timeline-entry.component.html',
  styleUrls: ['./chat-timeline-entry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ChatTimelineInfoEntryComponent,
    ChatTimelineParticipantMessagesEntryComponent,
    ChatTimelineParticipantChangeEntryComponent,
    ChatTimelinePendingMessagesEntryComponent,
    ChatTimelineUnreadTidemarkComponent
  ]
})
export class ChatTimelineEntryComponent {
  @Input() entry: TimeLineEntry;
  @Output() markAsRead = new EventEmitter<number>();
  @Output() retrySendMessage = new EventEmitter<number>();
  @Output() participantMessageAdded = new EventEmitter<string>();
  @Output() pendingMessageAdded = new EventEmitter<string>();
  @Output() upgradeClicked = new EventEmitter<void>();

  get entryType(): string {
    if (this.entry instanceof ChatInfo) return 'ChatInfo';
    if (this.entry instanceof ParticipantMessages) return 'ParticipantMessages';
    if (this.entry instanceof PendingMessages) return 'PendingMessages';
    if (this.entry instanceof ParticipantChange) return 'ParticipantChange';
    if (this.entry instanceof UnreadTidemark) return 'UnreadTidemark';
    return 'unknown';
  }
}
